"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPersistedState = exports.hydrate = exports.persistWrapper = void 0;
var persistWrapper_1 = __importDefault(require("./persistWrapper"));
exports.persistWrapper = persistWrapper_1.default;
var createPersistor_1 = __importDefault(require("./createPersistor"));
var hydrate = function (store) {
    var assertStore = store;
    assertStore.dispatch({ type: 'HYDRATE', payload: {} });
};
exports.hydrate = hydrate;
var clearPersistedState = function (store) {
    var assertStore = store;
    assertStore.dispatch({ type: 'CLEAR_STATE', payload: {} });
};
exports.clearPersistedState = clearPersistedState;
exports.default = createPersistor_1.default;
